module.exports = __webpack_public_path__ + "static/media/light-filet-mignon.e4cce149.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/light-filet-mignon.svg
// module id = 192
// module chunks = 0